import { IBaseIconProps } from "./IBaseIconProps";

export const PutBackIcon = ({ color = "currentColor" }: IBaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 24 30"
      x="0px"
      y="0px"
      fill={color}
    >
      <path d="M8,13.5v-2a.5.5,0,0,1,1,0v1.20038a3.49733,3.49733,0,1,1-.20508,3.20831.50044.50044,0,0,1,.916-.40332A2.50374,2.50374,0,1,0,10.00372,13H10.5a.5.5,0,0,1,0,1h-2A.49971.49971,0,0,1,8,13.5ZM18.50006,5.00006H16V5l-.72363-1.4472A.99992.99992,0,0,0,14.382,3H9.618a.99992.99992,0,0,0-.89441.5528L8,5v.00006H5.5a.5.5,0,0,0,0,1H18.50006a.5.5,0,0,0,0-1ZM6,8H18V18a3,3,0,0,1-3,3H9a3,3,0,0,1-3-3ZM7,18a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V9H7Z" />
    </svg>
  );
};
